module.exports = __webpack_public_path__ + "img/username_icon.a0943cce.svg";